
// This file is auto-generated by 'set-env.ts'.  Adjust any new variables there or configure variables with a .env file.

export const environment = {
	disableCacheInterceptor: false,
	disableBusinessContextInterceptor: false,
	
			exclusive: window['exclusive'],
			apiSettings: window['organizations'],
			apiUrl: window['apiUrl'],
			cmsUrl: window['cmsUrl'],
			cmsToken: window['cmsToken'],
			organizationId: window['organizationId'],
			cmsSiteId: window['cmsSiteId'],
			production: window['production'],
			local: window['local'] || false,
			requireReview: window['requireReview'],
			currencySymbol: window['currencySymbol'],
			currencyCode: window['currencyCode'],
			locale: window['locale'],
			cloudinaryCloudName: window['cloudinaryCloudName'],
			taskerEngineUrl: window['taskerEngineUrl'],
			cloudinaryProxyUrl: window['cloudinaryProxyUrl'],
			briaModifyIframeId: window['briaModifyIframeId'],
			hotjarVersion: window['hotjarVersion'],
			hotjarSiteId: window['hotjarSiteId'],
			wppOpenGtmId: window['wppOpenGtmId'],
			gtmId: window['gtmId'],
			analyticsDebugMode: window['analyticsDebugMode'],
			wppOpenHeapAppId: window['wppOpenHeapAppId'],
			wppOpenParentOrigin: window['wppOpenParentOrigin'],
			wppOpenDebug: window['wppOpenDebug'],
			sentryDsn: window['sentryDsn'] || '',
			sentryEnvironment: window['sentryEnvironment'] || 'unknown',
			sentryRelease: window['sentryRelease'] || '',
			sentryTracesSampleRate: window['sentryTracesSampleRate'] || '',
			sentryReplayEnabled: window['sentryReplayEnabled'] || false,
			sentryReplaySessionSampleRate: window['sentryReplaySessionSampleRate'] || '',
			sentryReplayOnErrorSampleRate: window['sentryReplayOnErrorSampleRate'] || ''
		
};
